import apiClient from './apiClient';

export interface Permission {
  role: string;
  permissions: string[];
  dashboardFeatures: string[];
}

export interface DashboardData {
  role: string;
  userName: string;
  permissions: string[];
  features: string[];
  quickActions: string[];
  // Role-specific fields
  activeLeases?: number;
  upcomingPayments?: number;
  overduePayments?: number;
  openMaintenanceRequests?: number;
  totalProperties?: number;
  pendingPayments?: number;
  pendingMaintenance?: number;
  managedProperties?: number;
  newMaintenanceRequests?: number;
  pendingMaintenanceRequests?: number;
  inspectionsDue?: number;
  assignedJobs?: number;
  completedJobs?: number;
  totalUsers?: number;
  totalLeases?: number;
  totalMaintenanceRequests?: number;
}

const permissionsApi = {
  // Get current user's permissions
  getMyPermissions: () => apiClient.get<Permission>('/permissions/me'),

  // Check if user has specific permission
  checkPermission: (permission: string) =>
    apiClient.get<{ hasPermission: boolean }>(`/permissions/check/${permission}`),

  // Get dashboard data for current user
  getDashboard: () => apiClient.get<DashboardData>('/dashboard'),

  // Get all roles and permissions (admin only)
  getAllRoles: () => apiClient.get<Record<string, Permission>>('/permissions/roles'),
};

export default permissionsApi;

